import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import { AiFillGithub, AiFillMail } from "react-icons/ai";
import { FaLinkedinIn, FaHackerrank } from "react-icons/fa";

function Experience() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1
              style={{ fontSize: "2.6em" }}
              className="text-decoration-underline"
            >
              Professional <span className="purple "> Experience </span>
            </h1>

            <div className="home-about-body">
              <p className="fw-bold purple">
                {" "}
                Software Engineer at Leaping Logic Ltd. ( 1 st July –To Present)
              </p>
              <ul>
                <li>
                  My responsibility involves designing websites using frameworks
                  like Vue.js, Nuxt, Bootstrap, and Tailwind.
                </li>
                <li>
                  As part of my role, I develop mobile applications using
                  Capacitor.js for cross-platform compatibility.
                </li>
                <li>
                  I handle the integration of payment gateways to ensure smooth
                  transactions within the application.
                </li>
                <li>
                  My responsibilities also include integrating various data
                  visualization graphs and displaying them on the frontend.
                </li>
                <li>
                  I utilize Python to integrate visualization data from Eagle
                  Eye Networks, ensuring it is accurately displayed on the
                  frontend.
                </li>
              </ul>

              <p className="fw-bold purple">
                {" "}
                Software Engineer (Intern) at W3 Engineers Ltd. ( 1 st December
                –1 st March )
              </p>
              <ul>
                <li>
                  My responsibility was to Scrap Data From Various Website by
                  Python-Spider
                </li>
                <li>
                  Comprehend the project's workflow, perform functional testing,
                  and develop APIs using Go, as guided by Go Convay
                </li>
              </ul>

              <p className="fw-bold purple">
                {" "}
                Software Engineer (Intern) at Xeon Technology Limited (17th
                September – 3rd November)
              </p>
              <ul>
                <li>
                  My responsibility was to Understand the existing code of
                  project
                </li>
                <li>
                  Implement Redux, RTK-Toolkit, Route, Context Api, Graphql and
                  many other thing
                </li>
                <li>Implement React-Bootstrap and CSS for styling</li>
              </ul>

              <p className="fw-bold purple">
                {" "}
                Software Developer at Maharishi Markandeshwar University
                (Intern) (January 2021 – June 2021)
              </p>
              <ul>
                {" "}
                <li>
                  {" "}
                  My responsibility involves converting user interface design
                  into high-quality, responsive code.{" "}
                </li>{" "}
                <li>
                  {" "}
                  I enhance user interactions to ensure a smooth and intuitive
                  application experience.{" "}
                </li>{" "}
                <li>
                  {" "}
                  I collect and manage user data with a focus on professionalism
                  and precision.{" "}
                </li>{" "}
                <li>
                  {" "}
                  I analyze and evaluate diverse software architectures used by
                  leading companies, including SBI, ICICI, Flipkart, and
                  Netflix.{" "}
                </li>{" "}
              </ul>
              <br />
            </div>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/NeazMorshed180031"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.hackerrank.com/neazmorshed_sd?hr_r=1"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaHackerrank />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/neazmorshedsd/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://mail.google.com/mail/?view=cm&fs=1&to=neazmorshed180031@gmail.com.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillMail />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Experience;
